import React from "react";
import { Paper, Text, Title, Grid } from "@mantine/core";

const theme = {};

const TenantInfoSection = ({ tenant }) => {
  if (!tenant) return null;

  return (
    <Paper shadow="xs" p="md" withBorder>
      <Title order={2} mb="md">
        Tenant Information
      </Title>
      <Grid>
        <Grid.Col span={6}>
          <Text fw={500}>Tenant Name</Text>
          <Text>{tenant.name || "—"}</Text>
        </Grid.Col>
        <Grid.Col span={6}>
          <Text fw={500}>Tenant ID</Text>
          <Text>{tenant.id || "—"}</Text>
        </Grid.Col>
      </Grid>
    </Paper>
  );
};

export default TenantInfoSection;
